const setValue = function(element, valueToSet = '', caseSensitive = false) {
    // If the element is really a collect of elements, then iterate over all the elements recursively
    if (NodeList.prototype.isPrototypeOf(element)) {
        if (element.length == 0) {
            return;
        }
        for (let index = 0, elementLength = element.length; index < elementLength; index++) {
            setValue(element[index], valueToSet, caseSensitive);
        }
        return;
    }
    if (element.tagName == 'SELECT') {
        if (element.options.length == 0) {
            return;
        }
        for (let index = 0, optionsLength = element.options.length; index < optionsLength; index++) {
            if (caseSensitive === true) {
                if (element.options[index].value.toLowerCase() == valueToSet.toLowerCase()) {
                    element.selectedIndex = index;
                }
            } else if (element.options[index].value == valueToSet) {
                element.selectedIndex = index;
            }
        }
        return element.options[element.selectedIndex];
    }

    if (element.tagName == 'INPUT') {
        if (element.getAttribute('type') == 'CHECKBOX') {
            if (element.value == valueToSet) {
                element.checked = true;
            }
            return;
        }
        if (element.getAttribute('type') == 'RADIO') {
            if (element.value == valueToSet) {
                element.selected = true;
            }
            return;
        }
    }

    element.value = valueToSet;
    return;
};

export default setValue;